var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 50px;\n  height: 45px;\n  position: relative;\n  margin-right: 11px;\n  margin-left: 12px;\n  margin-top:7px;\n  transform: rotate(0deg);\n  transition: .5s ease-in-out;\n  cursor: pointer;\n  &.open {\n    span:nth-child(1) { top: 16px; width: 0%; left: 50%; }\n    span:nth-child(2) { top: 16px; transform: rotate(45deg); }\n    span:nth-child(3) { transform: rotate(-45deg); }\n    span:nth-child(4) { top: 16px; width: 0%; left: 50%; }\n    @media(max-width: 700px){\n      span:nth-child(2) { top: 8px; transform: rotate(45deg); }\n    }\n  }\n  @media(max-width: 700px){\n    width: 25px;\n    margin-top: 28px;\n  }\n'], ['\n  width: 50px;\n  height: 45px;\n  position: relative;\n  margin-right: 11px;\n  margin-left: 12px;\n  margin-top:7px;\n  transform: rotate(0deg);\n  transition: .5s ease-in-out;\n  cursor: pointer;\n  &.open {\n    span:nth-child(1) { top: 16px; width: 0%; left: 50%; }\n    span:nth-child(2) { top: 16px; transform: rotate(45deg); }\n    span:nth-child(3) { transform: rotate(-45deg); }\n    span:nth-child(4) { top: 16px; width: 0%; left: 50%; }\n    @media(max-width: 700px){\n      span:nth-child(2) { top: 8px; transform: rotate(45deg); }\n    }\n  }\n  @media(max-width: 700px){\n    width: 25px;\n    margin-top: 28px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: block;\n  position: absolute;\n  height: 6px;\n  border-radius: 2px;\n  width: 100%;\n  background-color: ', ';\n  opacity: 1;\n  left: 0;\n  transform: rotate(0deg);\n  transition: .25s ease-in-out;\n  @media(max-width: 700px){\n    height: 3px;\n  }\n  &:nth-child(1) {\n    top: 0px;\n  }\n  &:nth-child(2) {\n\n  }\n  &:nth-child(3) {\n    top: 16px;\n    @media(max-width: 700px){\n      top: 8px;\n    }\n    \n  }\n  &:nth-child(4) {\n    top: 32px;\n    @media(max-width: 700px){\n      top: 16px;\n    }\n  }\n'], ['\n  display: block;\n  position: absolute;\n  height: 6px;\n  border-radius: 2px;\n  width: 100%;\n  background-color: ', ';\n  opacity: 1;\n  left: 0;\n  transform: rotate(0deg);\n  transition: .25s ease-in-out;\n  @media(max-width: 700px){\n    height: 3px;\n  }\n  &:nth-child(1) {\n    top: 0px;\n  }\n  &:nth-child(2) {\n\n  }\n  &:nth-child(3) {\n    top: 16px;\n    @media(max-width: 700px){\n      top: 8px;\n    }\n    \n  }\n  &:nth-child(4) {\n    top: 32px;\n    @media(max-width: 700px){\n      top: 16px;\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import colours from '../../Utils/colours';
var BurgerContainer = styled.div(_templateObject);
var Stripe = styled.span(_templateObject2, function (props) {
  return colours(props.theme, 'primary', 'base');
});

var Burger = function (_Component) {
  _inherits(Burger, _Component);

  function Burger() {
    _classCallCheck(this, Burger);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Burger.prototype.render = function render() {
    var open = this.props.open;
    return React.createElement(BurgerContainer, {
      className: open ? 'open' : ''
    }, React.createElement(Stripe, null), React.createElement(Stripe, null), React.createElement(Stripe, null), React.createElement(Stripe, null));
  };

  return Burger;
}(Component);

export default Burger;